export default async function GetInvestorDetails() {
    let url = window.RealestateService+  `/api/Investor/GetInvestorDetails`
    let head = {
         "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}